export default __webpack_public_path__ + "static/media/ao-safe-base-model.102e41d5.webp";